import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

// Owner values come from the owner dim, so a dashboard offers exactly the owners its charted points
// name — including owners of controls that have since been reassigned.
export const DashboardOwnerFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_OWNER}
      filterName={FilterName.DASHBOARD_OWNER}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="owner"
    />
  )
}
